import { BrowserRouter, Routes, Route } from 'react-router-dom'

import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import ProfilePage from './pages/ProfilePage'
import CasinoDetailPage from './pages/CasinoDetailPage'
import LoginPage from './pages/LoginPage'
import SignupPage from './pages/SignupPage'
import VerifyPage from './pages/VerifyPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import DataDeletionPage from './pages/DataDeletionPage'
import PwaUpdateBanner from './components/PwaUpdateBanner'
import OkDialog from './components/OkDialog'
import AgeGateDialog from './components/AgeGateDialog'

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/casinos/:slug" element={<CasinoDetailPage />} />
                <Route path="/signin" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/verify-email" element={<VerifyPage method="email" />} />
                <Route path="/verify-phone" element={<VerifyPage method="phone" />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/email-reset-password" element={<ResetPasswordPage />} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/data-deletion" element={<DataDeletionPage />} />
            </Routes>
            <PwaUpdateBanner />
            <OkDialog />
            <AgeGateDialog />
        </BrowserRouter>
    )
}
